import React, { useState } from "react";
import "./Reqprodcte.css";

const Reqprodcte = () => {
  const [formData, setFormData] = useState({
    name: "",
    company: "",
    email: "",
    country: "",
    state: "",   
    phone: "",
    requirement: "",
    message: ""
  });

  const [showForm, setShowForm] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const local_url = "http://localhost:5000/api/product_requests";
  const server_url = "https://dishamachines.com/api/product_requests";

  // Correct handleSubmit (API call to backend)
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch(server_url, { 
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData)
      });

      const data = await response.json();
      alert(` Server says: ${data.message}`); 
    } catch (error) {
      console.error(error);
      alert("Something went wrong");
    }
  };

  return (
    <div className="quote-form-container">
      <div className="form-button-container">
        <button className="form-button" onClick={() => setShowForm(true)}>
         Order Now
        </button>
      </div>

      {showForm && (
        <div className="modal-overlay">
          <div className="modal-form">
            <button className="close-btn" onClick={() => setShowForm(false)}>
              ×
            </button>
            <h2 className="quote-title">Request a Free Quote</h2>
            <p className="quote-description">
              Please let us know your requirements in detail, we will get back
              to you in 24 hours.
            </p>

            <form className="quote-form" onSubmit={handleSubmit}>
              <input
                type="text"
                name="name"
                placeholder="Name*"
                required
                value={formData.name}
                onChange={handleChange}
              />
              <input
                type="text"
                name="company"
                placeholder="Company"
                value={formData.company}
                onChange={handleChange}
              />
              <input
                type="email"
                name="email"
                placeholder="Email*"
                required
                value={formData.email}
                onChange={handleChange}
              />
              <input
                type="text"
                name="country"
                placeholder="Country*"
                required
                value={formData.country}
                onChange={handleChange}
              />

              {/* New State Input */}
              <input
                type="text"
                name="state"
                placeholder="State*"
                required
                value={formData.state}
                onChange={handleChange}
              />

              <input
                type="tel"
                name="phone"
                placeholder="Phone / WhatsApp"
                value={formData.phone}
                onChange={handleChange}
              />

              {/* Editable Dropdown */}
              <input
                list="requirements"
                name="requirement"
                placeholder="Select or Type Requirement*"
                value={formData.requirement}
                onChange={handleChange}
                required
              />
              <datalist id="requirements">
                <option value="Machine" />
                <option value="Spoon" />
                <option value="Plastic Bowl" />
                <option value="Other" />
              </datalist>

              <textarea
                name="message"
                placeholder="Your Message*"
                rows="4"
                required
                value={formData.message}
                onChange={handleChange}
              ></textarea>

              <button type="submit" className="submit-btn">
                Send
              </button>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default Reqprodcte;
